import { render } from "./MenuTableCellAllowChangeSortRow.vue?vue&type=template&id=00f70534&scoped=true"
import script from "./MenuTableCellAllowChangeSortRow.vue?vue&type=script&lang=js"
export * from "./MenuTableCellAllowChangeSortRow.vue?vue&type=script&lang=js"

import "./MenuTableCellAllowChangeSortRow.vue?vue&type=style&index=0&id=00f70534&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00f70534"]])

export default __exports__